<template>
    <div
        class="footer align-center justify-space-between text-center"
        :class="{ above: position === 'above' }"
    >
        © 2018 Corwin Design - Premium Calendars and Newsletters – Previously
        MyCorwinCalendar.com - All rights reserved
    </div>
</template>

<script>
export default {
    name: "Footer",
    props: ["position"]
};
</script>

<style lang="scss" scoped>
@use "../../assets/scss/mixins" as *;
@use "../../assets/scss/variables" as vars;

.footer {
    width: 100%;
    height: 40px;
    padding: 10px 10px;
    box-sizing: border-box;
    background: #242424;
    color: #777;
    margin-top: 2px;
    font-size: 14px;
    /*border-top-left-radius: 20px;*/
    &.above {
        box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.08);
        z-index: 1;
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        border-radius: 0;
    }

    a {
        font-weight: bold;
        text-decoration: none;
        color: vars.$text-color-accent;
    }

    .buy-btn {
        margin-left: 10px;
    }
}

@media (max-width: 768px) {
    .footer {
        padding: 0 12px;
        border-radius: 0;
    }
}
</style>
